import { render, staticRenderFns } from "./CustomerComplaintList.vue?vue&type=template&id=675e7f91&scoped=true"
import script from "./CustomerComplaintList.vue?vue&type=script&lang=js"
export * from "./CustomerComplaintList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675e7f91",
  null
  
)

export default component.exports